import React from 'react';
import { makeStyles } from '@material-ui/core';
import { PrivateImage } from 'features/authorize/private_img';

export const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        padding: '16px 16px 48px 16px',
        height: '100%',
        overflowY: 'hidden',
    },
    imageContainer: {
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
    },
    image: {
        width: '100%',
        maxHeight: '60vh',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
    },
    continueButton: {
        padding: '12px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#1A1A1A',
        color: '#ffffff',
        borderRadius: '50px',
        margin: '10px 0px',
        fontFamily: 'Poppins',
        fontSize: '14px',
    },
    skipButton: {
        padding: '12px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#000000',
        borderRadius: '50px',
        margin: '10px 0px',
        fontFamily: 'Poppins',
        fontSize: '14px',
        border: '1px solid',
    },
}));

function EditMyPhoto(props) {
    const { item, openImgModal, handlePhotoDeleteAlert } = props;
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <div className={classes.imageContainer}>
                <PrivateImage url={item.value} className={classes.image} key={`${item.answerUpdated}`} />
            </div>
            <div
                className={classes.continueButton}
                onClick={() => {
                    openImgModal(item);
                }}
            >
                RETAKE
            </div>
            <div
                className={classes.skipButton}
                onClick={() => {
                    handlePhotoDeleteAlert();
                }}
            >
                DELETE
            </div>
        </div>
    );
}

export default EditMyPhoto;
